import { OWN_GOAL_TYPE, SHOT_EVENT_TYPES } from '@/consts/visualisations';
import { MarkerEvent } from '@/types/event';
import { ShotMapEventMarker } from '@/types/visualisation';

export const isShotEvent = ({ type }: Pick<MarkerEvent, 'type'>) => SHOT_EVENT_TYPES.includes(type);

export const getShotEventMix = (...eventLists: Pick<MarkerEvent, 'type'>[][]) => {
  let hasShotEvents = false;
  let hasNonShotEvents = false;

  eventLists.forEach(events =>
    events.forEach(event => {
      if (isShotEvent(event)) {
        hasShotEvents = true;
      } else {
        hasNonShotEvents = true;
      }
    }),
  );

  return { hasShotEvents, hasNonShotEvents };
};

export const getShotMarkerShape = (event: ShotMapEventMarker) => {
  switch (true) {
    case event.type === OWN_GOAL_TYPE:
      return 'HEXAGON';
    case event.penalty || event.freeKick:
      return 'SQUARE';
    case event.followsThroughBall:
      return 'TRIANGLE';
    case event.followsDribble:
      return 'DIAMOND';
    case event.bodyPart === 'head':
      return 'CIRCLE';
    default:
      return 'HEXAGON';
  }
};
